module.exports = __webpack_public_path__ + "static/media/logo-w.3dd3f35a.png";